import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilesList } from '../../models/files';
import { FileManagerService } from './services/file-manager.service';
import { CommonModule } from '@angular/common';
import { DndDirective } from './drag-and-drop.directive';
import { DialogService } from '../dialog/dialog.service';
import { ConfirmModalComponent } from '../dialog/components/confirm-modal/confirm-modal.component';

@Component({
  selector: "app-upload-tool",
  standalone: true,
  imports: [CommonModule, DndDirective],
  templateUrl: "./upload-tool.component.html",
  styleUrls: ["./upload-tool.component.css"],
})
export class UploadToolComponent implements OnInit {
  @Output() filesList: EventEmitter<FilesList[]> = new EventEmitter();
  @Output() onChange: EventEmitter<Event> = new EventEmitter(null);
  @Input() standard = false;
  @Input() multiple = true;
  @Input() disabled = false;
  @ViewChild('fileUploader') fileUploader: ElementRef;
  onFocusFlag = false;
  randomId = Math.random() * 1000;
  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent): void {
    if(event.type === "click") {
      this.onFocusFlag = false;
    }
  }
  constructor(private fileManager: FileManagerService,
    private  router : Router,
    private dialog: DialogService) {}

  ngOnInit() {}

  /**
   * on file drop handler
   */
  onFileDropped(event) {
    if(this.checkFiles(event.files)){
      if(!this.standard) {
        this.uploadFile(event.files);
        this.onFocusFlag = false;
        //REDIRECT HOME
        this.router.navigateByUrl(`/welcome-board`);
      }
      this.onChange.emit(event.files);
    }
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event) {
    if(this.checkFiles(event.target.files)){
      if(!this.standard) {
        this.uploadFile(event.target.files);
        this.onFocusFlag = false;
        event.target.value = null;
      }
      this.onChange.emit(event.target.files);
      if(this.fileUploader) {
        this.fileUploader.nativeElement.value = null;
      }
    }
  }


  checkFiles(files: File[]): boolean {
    for(var file of files){
      if(!!file.name && file.name.indexOf('.') == -1){
        this.openErrorDialog("Il file di nome "+file.name+" deve contenere un'estensione.");
        return false;
      }
    }
    return true;
  }

  /**
   * Taking a list of files, upload them one by one to the server
   * @param files (Files List)
   */
  uploadFile(files) {
    const uploadArray = from(files)
      .pipe(
        map((file) => {
          this.fileManager.onFileUpload(file);
        })
      );
    forkJoin(uploadArray).subscribe();
    //REDIRECT HOME
    this.onFocusFlag = false;
    this.router.navigateByUrl(`/welcome-board`);
  }

  onFocus(event) {
    if(event) {
      this.onFocusFlag = true;
    }
  }

  openErrorDialog(message:string){
    this.dialog.removeDialogComponentFromBody();
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: message,
          data: [],
          hideButtons: true,
          confirmButton :true
        },
        style: {
          width: '50%',
          zIndex: '9999999 !important'
        },
        title: 'Errore',
      }
    });

  }

}
